export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Utente non trovato"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seleziona"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chiudi"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ricerca"])}
}